// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (max-width: 767px) {\n.mobile-header[data-v-50056650] {\n\t\tborder-radius: 24px 24px 0 0;\n\t\tmargin-top: 0;\n\t\tbackground-color: var(--c-dark-3);\n}\n.modal-title[data-v-50056650] {\n    padding: 16px 0;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
